"use client";

import Header from "@/components/layouts/Header";
import Footer from "@/components/layouts/Footer";
import PromoBanner from "@/components/layouts/PromoBanner";
import ApolloWrapper from "@/graphql/ApolloWrapper";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { persistor, store } from "@/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import QuickCart from "@/components/ui/QuickCart";
import WhatsAppButton from "@/components/ui/Whatsapp";
import BirthstoneButton from "@/components/ui/BirthstoneButton";
import SignupPopup from "@/components/ui/SignupPopup";
import "@/app/i18n";
import GlobalLoader from "@/components/GlobalLoader";

import { LoaderProvider } from "@/context/LoaderContext";
import { usePathname } from "next/navigation";

function MainContent({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isPage = pathname === "/" || pathname === "/register" || pathname === "/login" || pathname === '/verify';
console.log("page",isPage)
  return (
<main className={isPage ? "mt-0" :"mt-8"}>
      {children}
    </main>
  );
}

export default function RootLayoutClient({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const hideLayout = pathname === "/login" || pathname === "/register" || pathname === '/verify';

  // ✅ Check if homepage
  const isHomePage = pathname === "/" || pathname === "/home";

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <LoaderProvider>
            <ApolloWrapper>
              <GlobalLoader />

              {/* {!hideLayout && ( */}
                <>
                  {/* Promo Banner - Only shows on mobile */}
                  <PromoBanner />
                  <Header />

                  <QuickCart />
                  <WhatsAppButton />
                  <BirthstoneButton />
                  {/* Signup Popup - Shows after 10s or 20% scroll */}
                  <SignupPopup />
                </>
              {/* )} */}

              <MainContent>{children}</MainContent>

              <ToastContainer position="top-right" autoClose={3000} />

              {/* ✅ Hide Footer on homepage (it has its own inside smooth-content) */}
              {!hideLayout && !isHomePage && <Footer />}
              {/* <Footer/> */}
            </ApolloWrapper>
          </LoaderProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}